import en from './en';

export default {
  locales: { en },
  current: 'en',
};
